import RSAA from 'redux-api-middleware/lib/RSAA';
import { getJSON } from 'redux-api-middleware';
import { getQueryStringValueByName, getPayload } from '../../utils';
import { CASE_ID, ROUTE_SIGNIFICANT_PEOPLE_PAGE, OFFER_CASE_ID } from '../../utils/constants';
import { redirectToPage, technicalErrorPage } from '../../store/dataCapture';
import { getSignatoriesPayload } from './payloadUtils/signatoriesPayload';
import { mapSelectedAddresses } from './payloadUtils/addressPayloads';

export const ADD_OFFICER = 'ADD_OFFICER';
export const ADD_OFFICER_SUCCESS = 'ADD_OFFICER_SUCCESS';
export const ADD_OFFICER_FAILED = 'ADD_OFFICER_FAILED';
export const UPDATE_OFFICER = 'UPDATE_OFFICER';
export const UPDATE_OFFICER_SUCCESS = 'UPDATE_OFFICER_SUCCESS';
export const UPDATE_OFFICER_FAILED = 'UPDATE_OFFICER_FAILED';
export const DELETE_OFFICER = 'DELETE_OFFICER';
export const DELETE_OFFICER_SUCCESS = 'DELETE_OFFICER_SUCCESS';
export const DELETE_OFFICER_FAILED = 'DELETE_OFFICER_FAILED';
export const SAVE_OFFICER_DETAILS = 'SAVE_OFFICER_DETAILS';
export const SAVE_PERSONAL_DETAILS = 'SAVE_PERSONAL_DETAILS';
export const ON_SHAREHOLDER_VALUE_CHANGE = 'ON_SHAREHOLDER_VALUE_CHANGE';

export const addOfficer = (data, currentOfficerNumber, type) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/business/${getQueryStringValueByName(CASE_ID) ||
      getQueryStringValueByName(OFFER_CASE_ID)}/tasks/capture/officers`,
    method: 'POST',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    body: state => getSignatoriesPayload(data, state, currentOfficerNumber),
    types: [
      {
        type: ADD_OFFICER,
        meta: {
          loading: true
        }
      },
      {
        type: `${type ? `${type}_` : ''}${ADD_OFFICER_SUCCESS}`,
        payload: (_action, _state, res) =>
          getJSON(res).then(json => {
            res.json = json;
            return json;
          }),
        meta: (_action, state) => ({
          nextAction: redirectToPage(ROUTE_SIGNIFICANT_PEOPLE_PAGE),
          loading: false,
          data: mapSelectedAddresses(data, state, currentOfficerNumber)
        })
      },
      {
        type: ADD_OFFICER_FAILED,
        meta: {
          nextAction: technicalErrorPage(),
          loading: false,
          data: data
        }
      }
    ]
  }
});

export const updateOfficer = (data, id, routeUrl, type) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/business/${getQueryStringValueByName(CASE_ID) ||
      getQueryStringValueByName(OFFER_CASE_ID)}/tasks/capture/officers/${id}`,
    method: 'PUT',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    body: state => getSignatoriesPayload(data.officer, state, data.index),
    types: [
      {
        type: UPDATE_OFFICER,
        meta: {
          loading: true
        }
      },
      {
        type: `${type ? `${type}_` : ''}${UPDATE_OFFICER_SUCCESS}`,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: (_action, state) => ({
          nextAction: routeUrl ? redirectToPage(routeUrl) : '',
          loading: false,
          data: {
            officer: mapSelectedAddresses(data.officer, state, data.index),
            index: data.index
          }
        })
      },
      {
        type: UPDATE_OFFICER_FAILED,
        meta: {
          loading: false,
          data: data
        }
      }
    ]
  }
});

export const removeOfficer = (index, id) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/business/${getQueryStringValueByName(CASE_ID) ||
      getQueryStringValueByName(OFFER_CASE_ID)}/tasks/capture/officers/${id}`,
    method: 'DELETE',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: DELETE_OFFICER,
        meta: {
          loading: true
        }
      },
      {
        type: DELETE_OFFICER_SUCCESS,
        meta: {
          loading: false,
          index: index
        }
      },
      {
        type: DELETE_OFFICER_FAILED,
        meta: {
          loading: false,
          index: index
        }
      }
    ]
  }
});

export const savePersonDetails = (data, currentOfficerNumber) => ({
  type: SAVE_PERSONAL_DETAILS,
  meta: {
    nextAction: addOfficer(data, currentOfficerNumber)
  }
});

export const saveOfficerDetails = (data, index, id) => ({
  type: SAVE_OFFICER_DETAILS,
  meta: {
    nextAction: updateOfficer(
      {
        officer: data,
        index: index
      },
      id
    )
  }
});

export const removeOfficerDetails = (index, id) => ({
  type: SAVE_OFFICER_DETAILS,
  meta: {
    nextAction: removeOfficer(index, id)
  }
});

export const onOfficerValueChange = data => ({
  type: ON_SHAREHOLDER_VALUE_CHANGE,
  data: data
});
